








import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../main";
import * as data from "../_store/data.module";
import DocSignDialog from "./Dialogs/DocSignDialog.vue";

@Component({
  components: {
    DocSignDialog
  }
})

export default class ReportVisite extends Vue{
    @Prop() ispezione!: any;


}
